// @ts-nocheck
import stringHelper from './stringHelper';

/**
 * Shared utilities for sitemap models
 * Used by both CitySitemap and StateSitemap models
 */

export const extractResourceIdFromUriV2 = (uriV2) => {
  if (!uriV2 || typeof uriV2 !== 'string') return null;
  // Extract resourceId from "/san-francisco-ca/apartments-for-rent" -> "san-francisco-ca"
  const segments = uriV2.split('/');
  return segments.length >= 2 ? segments[1] : null;
};

export const areaGroupMapper = (areaGroups, header) => {
  if (!Array.isArray(areaGroups)) {
    return [];
  }

  return areaGroups
    .filter((areaGroup) => {
      // Only filter out areas with invalid or missing listing count data
      // Areas with 0 listings should be displayed (e.g., "0 apartments available")
      return (
        areaGroup &&
        typeof areaGroup === 'object' &&
        typeof areaGroup.listingCount === 'number' &&
        areaGroup.listingCount >= 0
      );
    })
    .map((areaGroup, index) => {
      const resourceId = extractResourceIdFromUriV2(areaGroup.uriV2);
      // Generate fallback ID if not provided by API
      const id = areaGroup.id || resourceId || `${areaGroup.name || 'area'}-${index}`;

      // Ensure we have safe fallback values for required fields
      const safeName = areaGroup.name || 'Unknown Area';
      const safeUriV2 = areaGroup.uriV2 || '';
      const safeListingCount = areaGroup.listingCount;

      return {
        ...areaGroup,
        id,
        resourceId,
        name: safeName,
        uriV2: safeUriV2,
        listingCount: safeListingCount,
        phrase: `${safeListingCount} ${stringHelper.getPhrase(safeListingCount, header)}`,
      };
    });
};

/**
 * Creates a property type reducer function with configurable area type mappings
 * @param {Object} areaTypeMap - Maps area types to property names (e.g., { city: 'cities', neighborhood: 'neighborhoods' })
 */
export const createPropertyTypeReducer = (areaTypeMap) => {
  return (acc, curr) => {
    if (curr.areaType && areaTypeMap[curr.areaType]) {
      acc[areaTypeMap[curr.areaType]] = areaGroupMapper(curr.areaGroups, curr.header);
    }
    return acc;
  };
};
